import { defineMessages } from "react-intl";

export const maintenanceMessages = defineMessages({
  pageTitle: {
    id: "maintenance.page.title",
    defaultMessage: "Maintenance Window",
  },
  pageDescription: {
    id: "maintenance.page.description",
    defaultMessage:
      "Users will be unable to access the application during this period.",
  },
  emptyTitle: {
    id: "maintenance.empty.title",
    defaultMessage: "No maintenance scheduled",
  },
  emptyDescription: {
    id: "maintenance.empty.description",
    defaultMessage:
      "Set a maintenance window to notify users in advance and automatically display a maintenance page during planned downtime.",
  },
  createMaintenance: {
    id: "maintenance.action.create",
    defaultMessage: "Schedule Maintenance",
  },
  schedule: { id: "maintenance.text.create", defaultMessage: "Schedule" },
  startsOn: { id: "maintenance.field.startsOn", defaultMessage: "Starts on" },
  selectDate: {
    id: "maintenance.field.selectDate",
    defaultMessage: "Select date",
  },
  endsOn: { id: "maintenance.field.endsOn", defaultMessage: "Ends on" },
  reminder: { id: "maintenance.field.reminder", defaultMessage: "Reminder" },
  reminderDescription: {
    id: "maintenance.field.reminder.description",
    defaultMessage:
      "Choose when users should start seeing the maintenance reminder.",
  },
  customDate: {
    id: "maintenance.reminder.customDate",
    defaultMessage: "Custom Date",
  },
  doNotNotify: {
    id: "maintenance.reminder.doNotNotify",
    defaultMessage: "Don't notify",
  },
  notifyImmediately: {
    id: "maintenance.reminder.notifyImmediately",
    defaultMessage: "Notify immediately",
  },
  notice: { id: "maintenance.field.notice", defaultMessage: "Notice" },
  noticeDescription: {
    id: "maintenance.field.notice.description",
    defaultMessage:
      "This message will be displayed on the maintenance page during downtime.",
  },
  writeMessage: {
    id: "maintenance.field.notice.placeholder",
    defaultMessage: "Write a message",
  },
  cancel: { id: "maintenance.action.cancel", defaultMessage: "Cancel" },
  abort: { id: "maintenance.action.abort", defaultMessage: "Abort" },
  goBack: { id: "maintenance.action.goBack", defaultMessage: "Go Back" },
  review: { id: "maintenance.action.review", defaultMessage: "Review" },
  reviewAndPublish: {
    id: "maintenance.review.title",
    defaultMessage: "Review & publish",
  },
  publish: { id: "maintenance.action.publish", defaultMessage: "Publish" },
  edit: { id: "maintenance.action.edit", defaultMessage: "Edit" },
  editMaintenance: {
    id: "maintenance.action.editWindow",
    defaultMessage: "Edit Maintenance Window",
  },
  maintenanceWindow: {
    id: "maintenance.section.window",
    defaultMessage: "Maintenance Window",
  },
  starts: { id: "maintenance.review.starts", defaultMessage: "Starts" },
  ends: { id: "maintenance.review.ends", defaultMessage: "Ends" },
  duration: { id: "maintenance.review.duration", defaultMessage: "Duration" },
  leadTime: { id: "maintenance.review.leadTime", defaultMessage: "Lead time" },
  scheduled: {
    id: "maintenance.scheduled.title",
    defaultMessage: "Maintenance Window Scheduled",
  },
  maintenanceStarts: {
    id: "maintenance.scheduled.starts",
    defaultMessage: "Maintenance Starts",
  },
  maintenanceEnds: {
    id: "maintenance.scheduled.ends",
    defaultMessage: "Maintenance Ends",
  },
  publishedSuccessfully: {
    id: "maintenance.toast.published",
    defaultMessage: "Maintenance window published successfully",
  },
  noValue: { id: "maintenance.value.empty", defaultMessage: "-" },
  notificationTitle: {
    id: "maintenance.notification.title",
    defaultMessage: "System maintenance",
  },
  willBeginOn: {
    id: "maintenance.notification.willBeginOn",
    defaultMessage: "will begin on",
  },
  downtimeTitle: {
    id: "maintenance.downtime.title",
    defaultMessage: "We're under maintenance",
  },
  downtimeDescription: {
    id: "maintenance.downtime.description",
    defaultMessage:
      "WorkPlanX is temporarily down for maintenance. Thanks for your patience. We'll be back shortly.",
  },
  expectedBackBy: {
    id: "maintenance.downtime.expectedBackBy",
    defaultMessage: "Expected back by",
  },
  historyPageTitle: {
    id: "maintenance.history.pageTitle",
    defaultMessage: "Maintenance History",
  },
  historyStartDate: {
    id: "maintenance.history.startDate",
    defaultMessage: "Start Date",
  },
  historyEndDate: {
    id: "maintenance.history.endDate",
    defaultMessage: "End Date",
  },
  historyDuration: {
    id: "maintenance.history.duration",
    defaultMessage: "Duration",
  },
  historyNotice: { id: "maintenance.history.notice", defaultMessage: "Notice" },
  historyStatus: { id: "maintenance.history.status", defaultMessage: "Status" },
  historyCreatedBy: {
    id: "maintenance.history.createdBy",
    defaultMessage: "Created By",
  },
  historyBack: { id: "maintenance.history.back", defaultMessage: "Back" },
  historyEmptySubtitle: {
    id: "maintenance.history.empty.subtitle",
    defaultMessage: "No maintenance history available.",
  },
  maintenanceCreated: {
    id: "maintenance.toast.created",
    defaultMessage: "Maintenance window created successfully",
  },
  maintenanceUpdated: {
    id: "maintenance.toast.updated",
    defaultMessage: "Maintenance window updated successfully",
  },
  maintenanceCancelled: {
    id: "maintenance.toast.cancelled",
    defaultMessage: "Maintenance window cancelled successfully",
  },
  cancelConfirmTitle: {
    id: "maintenance.cancel.title",
    defaultMessage: "Abort maintenance window?",
  },
  cancelConfirmDescription: {
    id: "maintenance.cancel.description",
    defaultMessage:
      "This maintenance window hasn't started yet. Aborting it will remove any reminder currently shown to users.",
  },
  discardChanges: {
    id: "maintenance.action.discard",
    defaultMessage: "Discard Changes",
  },
  reset: { id: "maintenance.action.reset", defaultMessage: "Reset" },
  startDateRequired: {
    id: "maintenance.schema.startDate.required",
    defaultMessage: "Start date is required",
  },
  startTimeRequired: {
    id: "maintenance.schema.startTime.required",
    defaultMessage: "Start time is required",
  },
  reminderDateRequired: {
    id: "maintenance.schema.reminderDate.required",
    defaultMessage: "Reminder date is required",
  },
  reminderTimeRequired: {
    id: "maintenance.schema.reminderTime.required",
    defaultMessage: "Reminder time is required",
  },
  endDateRequired: {
    id: "maintenance.schema.endDate.required",
    defaultMessage: "End date is required",
  },
  endTimeRequired: {
    id: "maintenance.schema.endTime.required",
    defaultMessage: "End time is required",
  },
  reminderBeforeStartRequired: {
    id: "maintenance.schema.reminder.beforeStart",
    defaultMessage: "Reminder must be before the maintenance start time",
  },
  historyScheduledStart: {
    id: "maintenance.history.scheduledStart",
    defaultMessage: "Scheduled Start",
  },
  historyScheduledEnd: {
    id: "maintenance.history.scheduledEnd",
    defaultMessage: "Scheduled End",
  },
  historyReminder: {
    id: "maintenance.history.reminder",
    defaultMessage: "Reminder",
  },
  historyReleasedOn: {
    id: "maintenance.history.releasedOn",
    defaultMessage: "Released On",
  },
  historyViewDetails: {
    id: "maintenance.history.viewDetails",
    defaultMessage: "View Details",
  },
  historyImmediately: {
    id: "maintenance.history.immediately",
    defaultMessage: "Immediately",
  },
  historyTableTitle: {
    id: "maintenance.history.tableTitle",
    defaultMessage: "Maintenance History",
  },
  historyNotFound: {
    id: "maintenance.history.notFound",
    defaultMessage: "Maintenance entry not found.",
  },
  historyDetailsTitle: {
    id: "maintenance.history.detailsTitle",
    defaultMessage: "Maintenance Details",
  },
  summary: {
    id: "maintenance.history.summary",
    defaultMessage: "Summary",
  },
  start: {
    id: "maintenance.history.start",
    defaultMessage: "Start",
  },
  end: {
    id: "maintenance.history.end",
    defaultMessage: "End",
  },
  noReminderSet: {
    id: "maintenance.history.noReminderSet",
    defaultMessage: "No reminder set",
  },
  noNoticeProvided: {
    id: "maintenance.history.noNoticeProvided",
    defaultMessage: "No notice provided",
  },
});
